import { EntitlementGroupInterface } from '@thro-types/access-handler';
import {
  SystemTile,
  ListResponse,
  WatchlistItem,
  CreateWatchlistItem,
  Category,
  CreateTile,
  Tile,
  UpdateTile,
  Icon,
  Layout,
  CreateOrUpdateLayout,
  UserLayout,
  CreateOrUpdateIcon,
  User
} from '@thro-types/users';

import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getWatchlist = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ListResponse<WatchlistItem>>('/users/v1/watchlist', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getCategories = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Category[]>('/users/v1/categories', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createWatchlistItem = async (
  watchListEntry: CreateWatchlistItem,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post('/users/v1/watchlist', watchListEntry, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteWatchlistItem = async (watchlistItemId: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete(`/users/v1/watchlist/${watchlistItemId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getTiles = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Tile[]>('/users/v1/tiles', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createIcon = async (
  createIconData: CreateOrUpdateIcon,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post<Icon>('/users/v1/tiles', createIconData, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createTile = async (createTileData: CreateTile, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.post<SystemTile>('/users/v1/tiles', createTileData, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateTile = async (
  tileId: number,
  updateTileData: UpdateTile,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch<Tile>(`/users/v1/tiles/${tileId}`, updateTileData, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteTile = async (tileId: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.delete(`/users/v1/tiles/${tileId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getIcons = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<Icon[]>('/users/v1/icons', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getLayout = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<UserLayout>('/users/v1/layouts', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const createLayout = async (
  createLayoutData: CreateOrUpdateLayout,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.post<Layout>('/users/v1/layouts', createLayoutData, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const updateLayout = async (
  layoutId: number,
  updateLayoutData: CreateOrUpdateLayout,
  config?: AxiosRequestConfig
) => {
  try {
    const response = await Gateway.patch<Layout>(
      `/users/v1/layouts/${layoutId}`,
      updateLayoutData,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getUsers = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<User[]>('/users/v1/users', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getMyEntitlementGroups = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<EntitlementGroupInterface[]>('/users/v1/users/self', config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
